import { render } from "./ContadorAtencionComponent.vue?vue&type=template&id=6f29c9ca"
import script from "./ContadorAtencionComponent.vue?vue&type=script&lang=js"
export * from "./ContadorAtencionComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__